import { useState } from "react";
import Form from "react-bootstrap/Form";
import EndpointInput from "./EndpointInput";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";

export default function StudyDesigner({
  initialDuration,
  initialThreshold,
  createUserDesign,
  disabled
}) {
  const [duration, setDuration] = useState(initialDuration);
  const [organ, setOrgan] = useState("Systemic");
  const [endpoint, setEndpoint] = useState("Body weight");
  const [redoCompute, setRedoCompute] = useState(true);
  const [threshold, setThreshold] = useState(initialThreshold);

  return (
    <div className="study-designer">
      <h4>Create a new study design</h4>
      <Form>
        <Row>
          <EndpointInput
            organ={organ}
            setOrgan={setOrgan}
            endpoint={endpoint}
            setEndpoint={setEndpoint}
          />
        </Row>
        <Row>
          <Form.Group controlId="studyForm.DurationInput">
            <Form.Label>
              <b>Duration</b>
            </Form.Label>
            <Form.Select
              type="text"
              value={duration}
              onChange={(e) => {
                setDuration(e.target.value);
              }}
            >
              <option value="acute">Acute</option>
              <option value="subchronic">Subchronic</option>
              <option value="chronic">Chronic</option>
            </Form.Select>
          </Form.Group>
          <Form.Group controlId="studyForm.DoseGroups">
            <Form.Label>
              <b>Threshold</b>
            </Form.Label>
            <Form.Control
              type="number"
              step={0.01}
              value={threshold}
              onChange={(e) => {
                setThreshold(e.target.value);
              }}
            />
          </Form.Group>
        </Row>
        <Form.Check
          type="checkbox"
          id="custom-switch"
          label="Recompute BMDs and Endpoint Sensitivities using the new design"
          checked={redoCompute}
          onChange={(e) => setRedoCompute(e.target.checked)}
        />
      </Form>
      <Button
        onClick={(e) => {
          e.preventDefault();
          createUserDesign({
            "durationLabel": duration,
            "endpoint": endpoint,
            "organ": organ,
            "threshold": threshold,
            "redoComputations": redoCompute,
          });
        }}
        className="dt-button"
        variant="primary"
        type="submit"
        style={{ width: "13rem" }}
        disabled={disabled}
      >
        Generate New Design
      </Button>
    </div>
  );
}
